<template>
  <div>
    <div v-if="error" class="alert alert-danger">
      {{error}}
    </div>
    <b-form @submit.prevent="onSubmit">

      <b-form-group id="ig2" label-for="paramValue" label="Название ">
        <b-form-input id="paramValue" type="text" required placeholder="Введите значение" v-model="prop.propName" autocomplete="off"></b-form-input>
      </b-form-group>

      <b-form-group id="ig2" label-for="paramValue" label="Код">
        <b-form-input id="paramValue" type="text" placeholder="Введите значение" v-model="prop.propCode" autocomplete="off"></b-form-input>
      </b-form-group>

      <b-button type="submit" class="btn-info" variant="primary">Сохранить</b-button>

    </b-form>
  </div>
</template>

<script>
import {host} from "@/constants";

export default {
  name: "AnalitPropEdit",
  props: {
    analitId: String,
    property: Object
},
  data () {
    return {
      error: null,
      prop: this.property ? this.property :{
        propId: null,
        propName: null,
        propCode: null
      }
    }
  },
  methods: {
    onSubmit() {
      let method = 'POST'
      if (this.property !== null) {
        method = 'PUT'
      }

      console.log(JSON.stringify(this.mu))
      fetch(host + '/rest/params/' + this.analitId + '/properties', {
        method: method,
        credentials: 'include',
        body: JSON.stringify(this.prop),
        headers: {'Content-Type': 'application/json; charset=utf-8'}
      }).then(response => response.json())
          .then(json => {
            if (json.resultCode == 0) {
              this.$emit('save-success')
            } else {
              this.error = json.resultCode + ' ' + json.message;
            }
          })
          .catch(error => {
            this.error = error
          })

    }
  }
}
</script>

<style scoped>

</style>